var React = require('react');

function Scooter (props) {
    return React.createElement("svg",props,[React.createElement("style",{"type":"text/css","key":0},"\n\t.st0{fill:none;stroke:#F85484;stroke-width:1.5;stroke-miterlimit:10;}\n"),React.createElement("polyline",{"className":"st0","points":"41.3,1.4 41.3,35.7 31.1,45.6 10.7,45.6 ","key":1}),React.createElement("line",{"className":"st0","x1":"34.1","y1":"1.4","x2":"45.4","y2":"1.4","key":2}),React.createElement("circle",{"className":"st0","cx":"6","cy":"45.6","r":"5.1","key":3}),React.createElement("circle",{"className":"st0","cx":"41.3","cy":"45.6","r":"5.1","key":4}),React.createElement("polyline",{"className":"st0","points":"0.9,38.3 9.8,38.3 14.9,45.6 ","key":5})]);
}

Scooter.defaultProps = {"height":"120px","width":"109px","x":"0px","y":"0px","viewBox":"0 0 47.5 52.2","style":{"enableBackground":"new 0 0 47.5 52.2"},"xmlSpace":"preserve"};

module.exports = Scooter;

Scooter.default = Scooter;
